import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type * as WS from '@trinity/chat/api/interfaces/workspace.brand';

type Props = IWorkspaceBrandId;
type Data = WS.GetBrand.Response;
type QueryKey = readonly [string];
type Options = UseQueryOptions<Data, AxiosResponse, Data, QueryKey>;

export const useFetchBrandQuery = (props: Props, options?: Options) => {
  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: [
      `get:workspaces/brands`,
      props?.brandId,
    ],
    queryFn: () => {
      return apiClient.workspaceBrands.getBrand({
        brandId: props.brandId,
      });
    },
    ...options,
  });
};